/* eslint-disable no-console */
import { msalInstance, b2cPolicies } from "../config/AuthProvider";
import Constants from "./Constants";
import AWSAPI from "./AWSAPI";

const CALLBACK_REDIRECT_SESSION_KEY = "ONSUCCESS_REDIRECT_URL";
const CALLBACK_REDIRECT_PASSWORD_URL = "REDIRECT_PASSWORD_URL";

class AuthHelper {
  static login() {
    try {
      msalInstance.loginRedirect(b2cPolicies.authorities.signIn);
    } catch (e) {
      console.error(e.getMessage());
    }
  }

  static register() {
    try {
      msalInstance.loginRedirect(b2cPolicies.authorities.signUp);
    } catch (e) {
      console.error(e.getMessage());
    }
  }

  static isCountryAllowed(countryCode) {
    AWSAPI.getAllowedCountries().then((res) => {
      const allowedCountries = res.data;
      if (!allowedCountries.includes(countryCode)) {
        window.location.replace("/country-not-available");
      }
    });
  }

  static isRegisteredFromReply(email) {
    const replayDomains = [
      "reply.it",
      "reply.eu",
      "ringmaster.it",
      "bitmama.it",
      "xister.com",
      "reply.com",
      "reply.de",
      "valorem.com",
    ];
    return replayDomains.includes(email.split("@")[1]);
  }

  static getAccount() {
    const accounts = msalInstance.getAllAccounts();
    return accounts.length > 0 ? accounts[0] : null;
  }

  static getFirstName() {
    const account = this.getAccount();
    return account && account.idTokenClaims?.given_name;
  }

  static getLastName() {
    const account = this.getAccount();
    return account && account.idTokenClaims?.family_name;
  }

  static getFullName() {
    return `${this.getFirstName()} ${this.getLastName()}`;
  }

  static getEmail() {
    const account = this.getAccount();
    return (
      account &&
      ((account.idTokenClaims?.emails && account.idTokenClaims.emails[0]) ||
        account.idTokenClaims?.["signInNames.emailAddress"] ||
        account.idTokenClaims?.email)
    );
  }

  static getInitials() {
    return this.getInitial(this.getFirstName()) + this.getInitial(this.getLastName());
  }

  static getRole() {
    const account = this.getAccount();
    return account && account.idTokenClaims?.jobTitle;
  }

  static getCompany() {
    const account = this.getAccount();
    return account && account.idTokenClaims?.extension_Company;
  }

  static getInitial(s) {
    return s && s[0].toUpperCase();
  }

  static isReplyUser() {
    return sessionStorage.getItem(Constants.IS_LOGGED_IN_USER_REPLYER);
  }

  static isQualifiedITUser() {
    return sessionStorage.getItem(Constants.IS_LOGGED_IN_USER_QUALIFIED_INNOVATION_TOUR);
  }

  // static isQualifiedWEUser() {
  //   return sessionStorage.getItem(Constants.IS_LOGGED_IN_USER_QUALIFIED_WEBINARS);
  // }

  static saveCurrentLocationBeforeLogin() {
    if (window.location.pathname !== "/") {
      sessionStorage.setItem(
        CALLBACK_REDIRECT_SESSION_KEY,
        window.location.pathname + window.location.search,
      );
    }
  }

  static redirectToSavedLocation(setIsLoading) {
    if (sessionStorage.getItem(CALLBACK_REDIRECT_SESSION_KEY)) {
      if (
        sessionStorage.getItem(CALLBACK_REDIRECT_SESSION_KEY) !==
        window.location.pathname + window.location.search
      ) {
        window.location.href = sessionStorage.getItem(CALLBACK_REDIRECT_SESSION_KEY);
      }
      this.clearSavedRedirectLocation();
    } else {
      setIsLoading(false);
    }
  }

  static clearSavedRedirectLocation() {
    sessionStorage.removeItem(CALLBACK_REDIRECT_SESSION_KEY);
  }

  static savePasswordLocation() {
    sessionStorage.setItem(CALLBACK_REDIRECT_PASSWORD_URL, "/my-profile");
  }

  static clearSavedRedirectPasswordLocation() {
    if (sessionStorage.getItem(CALLBACK_REDIRECT_PASSWORD_URL)) {
      window.location.href = sessionStorage.getItem(CALLBACK_REDIRECT_PASSWORD_URL);
    }
    sessionStorage.removeItem(CALLBACK_REDIRECT_PASSWORD_URL);
  }

  static getUserOid() {
    const account = this.getAccount();
    return account && account.idTokenClaims?.oid;
  }

  static getUserRegisteredFrom() {
    const account = this.getAccount();
    return account && account.idTokenClaims?.extension_userRegisteredFrom;
  }

  static getUserType() {
    const account = this.getAccount();
    return account && account.idTokenClaims?.extension_userType;
  }
}

export default AuthHelper;
